import { createAction } from 'redux-actions';
import * as actionTypes from './constants';

export const fetchPlants = createAction(actionTypes.FETCH_WORKING_PLANTS_REQUEST);
export const fetchPlantsSuccess = createAction(actionTypes.FETCH_WORKING_PLANTS_SUCCESS);
export const fetchPlantsFailure = createAction(actionTypes.FETCH_WORKING_PLANTS_FAILURE);

export const fetchWorkingHours = createAction(actionTypes.FETCH_WORKING_HOURS_REQUEST);
export const fetchWorkingHoursSuccess = createAction(actionTypes.FETCH_WORKING_HOURS_SUCCESS);
export const fetchWorkingHoursFailure = createAction(actionTypes.FETCH_WORKING_HOURS_FAILURE);

export const updateWorkingHours = createAction(actionTypes.UPDATE_WORKING_HOURS_REQUEST);
export const updateWorkingHoursSuccess = createAction(actionTypes.UPDATE_WORKING_HOURS_SUCCESS);
export const updateWorkingHoursFailure = createAction(actionTypes.UPDATE_WORKING_HOURS_FAILURE);

export const restoreWorkingHours = createAction(actionTypes.RESTORE_WORKING_HOURS_REQUEST);
export const restoreWorkingHoursSuccess = createAction(actionTypes.RESTORE_WORKING_HOURS_SUCCESS);
export const restoreWorkingHoursFailure = createAction(actionTypes.RESTORE_WORKING_HOURS_FAILURE);

export const setDefaultWorkingHours = createAction(actionTypes.SET_DEFAULT_WORKING_HOURS);
